// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__3OtYm","headerIcon":"header_headerIcon__37H1O","headerText":"header_headerText__3v4CU"};